import SifAuBaseSerializer from './base';

export default class Zone extends SifAuBaseSerializer {}
